var CONST = {
    emarsys_confirmation_trigger: 5344,
    // Same-origin App Proxy: Shopify signs the call and forwards it to the API
    // /storefront/newsletter. No credentials in this file.
    newsletter_api: '/apps/api/newsletter'
};

function getUrlParameter(parameterName) {
    parameterName = parameterName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + parameterName + '=([^&#]*)'),
        matches = regex.exec(location.search);
    return null === matches ? '' : decodeURIComponent(matches[1].replace(/\+/g, ' '))
}

/**
 * POST JSON to the newsletter API through the App Proxy
 * @returns {Promise<{ status: number, body: object }>}
 */
async function postNewsletter(path, payload) {
    const response = await fetch(CONST.newsletter_api + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    });
    let body = {};
    try { body = await response.json(); } catch (_err) { body = {}; }
    return { status: response.status, body };
}

function buildFormData(formData) {
    return {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email
    };
}

function setFormData(userData) {
    // Set email field
    document.getElementById('email').value = userData.email || '';
    document.getElementById('email').disabled = true;

    // Set personal information fields
    document.getElementById('firstname').value = userData.first_name || '';
    document.getElementById('lastname').value = userData.last_name || '';
    document.getElementById('birth_date').value = userData.birth_date || '';
    document.getElementById('nif').value = userData.nif || '';

    // Set store preference
    document.getElementById('stores_near').value = userData.prefered_store_id || '';

    // Set ID fields
    document.getElementById('shopify_id').value = userData.shopify_id || '';

    // Set unsubscribe email display
    document.getElementById('email-unsubscribe').innerHTML = userData.email || '';
}

function showModal(showFooter, modalId) {
    var modal = new tingle.modal({
        footer: showFooter,
        stickyFooter: !1,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: 'Close',
        cssClass: [modalId],
        beforeClose: function beforeClose() {
            return !0
        }
    });
    showFooter && modal.addFooterBtn('Ir a la home', 'tingle-btn fa-after fa-angle-right btn button is-black btn-outline', function() {
        window.location.href = 'https://canarias.mediamarkt.es'
    }), modal.setContent(document.getElementById(modalId).innerHTML), modal.open()
}

function serializeForm(formSelector) {
    // Enable email field for serialization
    document.getElementById('email').disabled = false;

    // Serialize form data
    const formData = {};
    $(formSelector).serializeArray().forEach(function(field) {
        formData[field.name] = field.value || '';
    });
    return formData;
}

async function formMMSubmit() {
    try {
        if(!document.getElementById('formulario-mm').checkValidity()) {
            return;
        }

        const form = serializeForm('#formulario-mm');
        if(!form.email){
            showModal(!1, 'modalError');
            console.error('Customer email required');
            return;
        }

        // Same answer for new and existing emails; the API sends the opt-in email
        const { status } = await postNewsletter('/subscribe', buildFormData(form));
        if (status !== 202) throw new Error('Newsletter subscribe failed: ' + status);

        return true;
    } catch (err) {
        console.error('Error in formMMSubmit:', err);
        showModal(!1, 'modalError');
        return false;
    }
}

function submitLoading(buttonId, action) {
    if (action === 'show') {
        document.getElementById(buttonId).classList.add('bt-loading');
        document.getElementById(buttonId).classList.remove('is-black');
    } else if (action === 'hide') {
        document.getElementById(buttonId).classList.remove('bt-loading');
        document.getElementById(buttonId).classList.add('bt-done');
        setTimeout(function() {
            document.getElementById(buttonId).classList.add('bt-finish')
        }, 1500);
    }
}

function addCustomerToElevarDataLayer(customer) {
    window.ElevarDataLayer = window.ElevarDataLayer || [];
    if (window.ElevarDataLayer.some(element => element.event === "dl_subscribe")) return;

    window.ElevarDataLayer.push({
        event: "dl_subscribe",
        lead_type: "email",
        user_properties: {
            customer_email: customer.email,
            customer_name: customer.first_name,
            customer_surname: customer.last_name
        }
    });
}

function isFormValid(formId) {
    return !!document.getElementById(formId).checkValidity()
}

(async () => {
    let status = getUrlParameter('status').toLowerCase();

    // Handle user confirmation if status parameter exists
    status && new Promise(async () => {
        // Handle confirmed status - Opt-in confirmation received
        if('confirmed' === status && getUrlParameter('id')) {
            const { status: confirmStatus } = await postNewsletter('/confirm', { token: getUrlParameter('id') });
            if (confirmStatus !== 200) console.error('Newsletter confirmation failed: ' + confirmStatus);
        }
    });

    window.onload = function() {
        $('#formulario-mm').submit(function(d) { d.preventDefault(); });

        $('#btn-success').click(async function() {

            if(status == 'register' || !isFormValid('formulario-mm')) return;
            submitLoading('btn-success', 'show');

            const result = await formMMSubmit();
            if(result){ showModal(!1, 'modalConfirmRegister'); status = 'register'; }

            submitLoading('btn-success', 'hide');
        });

        $('#btn-subscribe').click(function() {
            'subscribe' != status && isFormValid('formulario-mm') ? (submitLoading('btn-subscribe', 'show'), formMMSubmit().then(function() {
                showModal(!0, 'modalConfirmSubscribe'), status = 'subscribe', submitLoading('btn-subscribe', 'hide')
            })) : 'subscribe' === status && showModal(!0, 'modalConfirmSubscribe')
        });

        // The unsubscribe panel is hidden and never called the API; unsubscribing
        // is done from the link in the marketing emails
        $('#btn-unsubscribe').click(function() {
            showModal(!0, 'modalConfirmUnsubscribe');
        });
    }
})();
